module.exports = "files/marioLose.mp3";